import { render, staticRenderFns } from "./AdjuntosRetiro.vue?vue&type=template&id=96cd7dd6"
import script from "./AdjuntosRetiro.vue?vue&type=script&lang=js"
export * from "./AdjuntosRetiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports